import { Button, HStack, Spinner, Text, VStack } from '@chakra-ui/react'
import { FiPrinter } from 'react-icons/fi'
import { useParams } from 'react-router-dom'
import { PageContainer } from '../components/shared/PageContainer'
import { ReportRenderer } from '../components/reporting/ReportRenderer'
import { useReportRun } from '../hooks/useReports'
import { reportsApi } from '../lib/api'

export function ReportRunPage() {
  const { runId } = useParams()
  const { data, isLoading, error } = useReportRun(runId)

  if (isLoading) {
    return (
      <PageContainer title="Report">
        <VStack py={12}>
          <Spinner size="lg" color="accent" />
        </VStack>
      </PageContainer>
    )
  }
  if (!!error || !data) {
    return (
      <PageContainer title="Report">
        <Text>That report run could not be loaded.</Text>
      </PageContainer>
    )
  }

  return (
    <PageContainer
      className="report-root"
      title={data.title}
      subtitle={`As of ${new Date(data.generatedAt).toLocaleString()}`}
      actions={
        <HStack className="no-print" gap={2}>
          <Button size="sm" variant="outline" onClick={() => window.print()}>
            <FiPrinter /> Print / Save PDF
          </Button>
        </HStack>
      }
    >
      <ReportRenderer
        result={data}
        onExportCsv={(blockId) => {
          // Direct navigation, not an axios call: the browser handles the file download and the
          // auth cookie rides along.
          window.location.assign(reportsApi.csvUrl(runId as string, blockId))
        }}
      />
    </PageContainer>
  )
}
